export class ServerModel{
    id:number;
    hostName:string;
    domainName:string;
}